import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, BarChart3, BookOpen } from "lucide-react";

const STORAJINI_URL = "https://storajini.com";
const LOGO = "/storajini-logo-full.png";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  // Storage & Parking link to main site; Compare/Blog stay internal for SEO
  const navLinks = [
    { label: "Storage", href: `${STORAJINI_URL}/search`, external: true },
    { label: "Parking", href: `${STORAJINI_URL}/search`, external: true },
    { label: "Compare", href: "/compare" },
    { label: "Blog", href: "/blog" },
  ];

  const renderNavLink = (link) => {
    if (link.external) {
      return (
        <a
          key={link.label}
          href={link.href}
         
         
          data-testid={`nav-${link.label.toLowerCase()}`}
          className="px-3 py-2 text-sm font-medium text-gray-600 hover:text-amber-600 rounded-md hover:bg-amber-50 transition-colors"
        >
          {link.label}
        </a>
      );
    }
    return (
      <Link
        key={link.label}
        to={link.href}
        data-testid={`nav-${link.label.toLowerCase()}`}
        className="px-3 py-2 text-sm font-medium text-gray-600 hover:text-amber-600 rounded-md hover:bg-amber-50 transition-colors"
      >
        {link.label}
      </Link>
    );
  };

  return (
    <nav data-testid="main-navbar" role="navigation" aria-label="Main navigation" className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100 shadow-sm">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-amber-500 focus:text-white focus:rounded-lg">Skip to content</a>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="navbar-logo">
            <img src={LOGO} alt="Storajini" className="h-10" />
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map(renderNavLink)}
            <a
              href={`${STORAJINI_URL}/search`}
             
             
              data-testid="nav-find-space-btn"
              className="ml-3 px-5 py-2 bg-amber-500 text-white text-sm font-semibold rounded-md hover:bg-amber-600 transition-colors"
            >
              Find Space
            </a>
          </div>

          {/* Mobile toggle */}
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2 text-gray-600 hover:text-gray-900"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-gray-100 bg-white animate-fade-in">
          <div className="px-4 py-3 space-y-1">
            {navLinks.map((link) => {
              if (link.external) {
                return (
                  <a key={link.label} href={link.href} onClick={() => setIsOpen(false)} className="block px-3 py-2.5 text-base font-medium text-gray-700 hover:text-amber-600 hover:bg-amber-50 rounded-md">
                    {link.label}
                  </a>
                );
              }
              return (
                <Link key={link.label} to={link.href} onClick={() => setIsOpen(false)} className="block px-3 py-2.5 text-base font-medium text-gray-700 hover:text-amber-600 hover:bg-amber-50 rounded-md">
                  {link.label}
                </Link>
              );
            })}
            <a href={`${STORAJINI_URL}/search`} className="block mt-2 px-4 py-2.5 bg-amber-500 text-white text-center font-semibold rounded-md">
              Find Space on Storajini
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
